import { Coachmark, localize } from '@spacegame/ui';
import { useTutorial } from './TutorialProvider';
import { TOUR_STEPS } from './tour';

const LABELS = {
  next: { de: 'Weiter', en: 'Next' },
  prev: { de: 'Zurück', en: 'Back' },
  finish: { de: 'Fertig', en: 'Finish' },
  skip: { de: 'Tour überspringen', en: 'Skip tour' },
} as const;

/** Renders the active tour step as a spotlight overlay, or nothing outside a tour. */
export function GuidedTour() {
  const tutorial = useTutorial();
  const step = TOUR_STEPS[tutorial.tourStepIndex];
  if (!tutorial.tourActive || !step) return null;

  const t = (entry: (typeof LABELS)[keyof typeof LABELS]) => localize(entry, tutorial.locale);
  const isLast = tutorial.tourStepIndex >= tutorial.tourStepCount - 1;
  const isFirst = tutorial.tourStepIndex === 0;

  return (
    <Coachmark
      open
      targetSelector={step.targetSelector}
      revealSelector='[data-tour="nav-more"]'
      title={localize(step.title, tutorial.locale)}
      body={localize(step.body, tutorial.locale)}
      step={tutorial.tourStepIndex + 1}
      stepCount={tutorial.tourStepCount}
      onNext={isLast ? undefined : tutorial.nextTourStep}
      onPrev={isFirst ? undefined : tutorial.prevTourStep}
      onSkip={tutorial.stopTour}
      nextLabel={t(LABELS.next)}
      prevLabel={t(LABELS.prev)}
      finishLabel={t(LABELS.finish)}
      skipLabel={t(LABELS.skip)}
    />
  );
}
